export enum SignatureStatus {
  Sent = 'sent',
  Signed = 'signed',
  SignedByAll = 'signedByAll',
  Voided = 'voided',
}
